// extracted by mini-css-extract-plugin
module.exports = {"Card":"page-not-found_Card__3wYDO","heading":"page-not-found_heading__3vAw6","check":"page-not-found_check__C1nvk"};